// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import wx from 'weixin-js-sdk'
import store from './store/store.js';
import login from './common/login.js' //引入授权登录js

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.wx = wx
Vue.prototype.login = login //引入公共js

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js